import { normalizeLessonNumbers } from './utils/normalizeLessonNumbers';
import { runtimeQuotaApiFeatureName } from './utils/runtimeQuotaFeatureIdentity';

export const TUTOR_QUERY_ROOT = 'tutor' as const;

export function tutorProgressBatchQueryKey(params: {
  membershipKey: string;
  studentKey: string;
  grade: number | null | undefined;
  lessonNumbers: readonly number[];
}): readonly [
  typeof TUTOR_QUERY_ROOT,
  'progress-batch',
  string,
  string,
  number | 'unknown-grade',
  string,
] {
  const normalized = normalizeLessonNumbers(params.lessonNumbers);
  return [
    TUTOR_QUERY_ROOT,
    'progress-batch',
    params.membershipKey,
    params.studentKey,
    params.grade ?? 'unknown-grade',
    normalized.join(','),
  ] as const;
}

export function tutorRuntimeQuotaQueryKey(params: {
  membershipKey: string;
  studentKey: string;
  featureName: string;
}): readonly [typeof TUTOR_QUERY_ROOT, 'runtime-quota', string, string, string] {
  return [
    TUTOR_QUERY_ROOT,
    'runtime-quota',
    params.membershipKey,
    params.studentKey,
    runtimeQuotaApiFeatureName(params.featureName),
  ] as const;
}

export function isTutorRuntimeQuotaQueryKey(
  queryKey: readonly unknown[],
  featureName?: string,
): boolean {
  if (queryKey.length < 5) return false;
  if (queryKey[0] !== TUTOR_QUERY_ROOT || queryKey[1] !== 'runtime-quota') return false;
  if (featureName == null) return true;
  return queryKey[4] === runtimeQuotaApiFeatureName(featureName);
}

export function experienceBootstrapQueryKey(params: {
  membershipKey: string;
  studentKey: string;
  experience: string;
  featureName: string;
  includeLessonIndex: boolean;
  grade?: number | null;
  lessonNo?: number | null;
  sublessonNo?: number | null;
}): readonly [
  typeof TUTOR_QUERY_ROOT,
  'experience-bootstrap',
  string,
  string,
  string,
  string,
  '0' | '1',
  number | 'none',
  number | 'none',
  number | 'none',
] {
  return [
    TUTOR_QUERY_ROOT,
    'experience-bootstrap',
    params.membershipKey,
    params.studentKey,
    params.experience,
    params.featureName || 'default',
    params.includeLessonIndex ? '1' : '0',
    params.grade ?? 'none',
    params.lessonNo ?? 'none',
    params.sublessonNo ?? 'none',
  ] as const;
}
